(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
		class LocalizationForm extends HTMLElement {
			constructor() {
			super();
			this.elements = {
				input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
				button: this.querySelector('button'),
				panel: this.querySelector('ul'),
			};
			this.elements.button.addEventListener('click', this.openSelector.bind(this));
			this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
			this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
			}
		
			onItemClick(event) {
			event.preventDefault();
			this.elements.input.value = event.currentTarget.dataset.value;
			this.querySelector('form')?.submit();
			}
		
			openSelector() {
			this.elements.button.focus();
			this.elements.panel.toggleAttribute('hidden');
			this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
			}
		
			closeSelector(event) {
			const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
			if (event.relatedTarget === null || shouldClose) {
				this.elements.button.setAttribute('aria-expanded', 'false');
				this.elements.panel.setAttribute('hidden', true);
			}
			}
		}
		customElements.define('localization-form', LocalizationForm);
	
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
	var sideBarLeft = document.getElementById('sidebar_left');
	var sideBarRight = document.getElementById('sidebar_right');
	
	update = () => {
		if( window.innerWidth > 1199) {
			if (sideBarLeft != null) 
				sideBarLeft.classList.remove("offcanvas","offcanvas-start");
			if (sideBarRight != null) 
				sideBarRight.classList.remove("offcanvas","offcanvas-end");
		} else {
			if (sideBarLeft != null) 
				sideBarLeft.classList.add("offcanvas","offcanvas-start");
			if (sideBarRight != null) 
				sideBarRight.classList.add("offcanvas","offcanvas-end");
		}
	}
	if (sideBarLeft != null || sideBarRight != null) {
		window.update();
		window.addEventListener('resize', update);
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
	var sideBarLeft = document.getElementById('sidebar_left');
	var sideBarRight = document.getElementById('sidebar_right');
	
	update = () => {
		if( window.innerWidth > 1199) {
			if (sideBarLeft != null) 
				sideBarLeft.classList.remove("offcanvas","offcanvas-start");
			if (sideBarRight != null) 
				sideBarRight.classList.remove("offcanvas","offcanvas-end");
		} else {
			if (sideBarLeft != null) 
				sideBarLeft.classList.add("offcanvas","offcanvas-start");
			if (sideBarRight != null) 
				sideBarRight.classList.add("offcanvas","offcanvas-end");
		}
	}
	if (sideBarLeft != null || sideBarRight != null) {
		window.update();
		window.addEventListener('resize', update);
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
    class CartNote extends HTMLElement {
        constructor() {
        super();

        this.addEventListener('change', debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
        }, 300))
        }
    }
    customElements.define('cart-note', CartNote);

  

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
	class ProductRecommendations extends HTMLElement {
		constructor() {
		super();
		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) return;
			observer.unobserve(this);
			fetch(this.dataset.url)
			.then(response => response.text())
			.then(text => {
				const html = document.createElement('div');
				html.innerHTML = text;
				const recommendations = html.querySelector('product-recommendations');
				if (recommendations && recommendations.innerHTML.trim().length) {
					this.innerHTML = recommendations.innerHTML;
					var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
                    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
                      	return new bootstrap.Tooltip(tooltipTriggerEl)
                    });
				}
              $(".recommend_product_slide").slick({
                slidesToShow: 4,
                infinite: true,
                slidesToScroll: 1,
                autoplay: false,
                autoplaySpeed: 2000,
                dots: false,
                prevArrow: '<button class="slick-prev slick-arrow"><svg width="30" height="50" viewBox="0 0 30 50" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M-9.33768e-07 25.0001C-9.59176e-07 24.4189 0.244371 23.837 0.732493 23.3933L25.7324 0.66605C26.7092 -0.222017 28.2911 -0.222017 29.2673 0.66605C30.2436 1.55412 30.2442 2.99218 29.2673 3.87968L6.03497 25.0001L29.2673 46.1205C30.2442 47.0086 30.2442 48.4467 29.2673 49.3342C28.2905 50.2217 26.7086 50.2222 25.7324 49.3342L0.732493 26.6069C0.244371 26.1632 -9.08361e-07 25.5814 -9.33768e-07 25.0001Z" fill="currentColor"/></svg></button>',
                nextArrow: '<button class="slick-next slick-arrow"><svg width="30" height="50" viewBox="0 0 30 50" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M30 25.0001C30 24.4189 29.7556 23.837 29.2675 23.3933L4.26763 0.66605C3.29076 -0.222017 1.7089 -0.222017 0.732653 0.66605C-0.243593 1.55412 -0.244218 2.99218 0.732652 3.87968L23.965 25.0001L0.732651 46.1205C-0.24422 47.0086 -0.24422 48.4467 0.73265 49.3342C1.70952 50.2217 3.29139 50.2222 4.26763 49.3342L29.2675 26.6069C29.7556 26.1632 30 25.5814 30 25.0001Z" fill="currentColor"/></svg></button>',
                arrows: false,
                responsive: [
                    {
                    breakpoint: 1400,
                    settings: {
                    slidesToShow: 3,
                    }
                    },
                    {
                    breakpoint: 768,
                    settings: {
                    slidesToShow: 2,
                    }
                    },
                    {
                    breakpoint: 576,
                    settings: {
                    slidesToShow: 1,
                    centerMode: true,
                    centerPadding:'89px',
                    }
                    },
                    {
                    breakpoint: 370,
                    settings: {
                    slidesToShow: 1,
                    centerMode: true,
                    centerPadding:'50px',
                    }
                  }
                ]
              });
			})
			.catch(e => {
				console.error(e);
			});
		}
	
		new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
		}
	}
	customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
